import React, {useState} from "react";
import EATabs from "../../EATabs";
import EABetriebsakteMainContainer from "../EABetriebsakteMainContainer";
import EABetriebsakteDatenContainer from "../EABetriebsakteDatenContainer";
import {useForm} from "../../../utils/FormUtils";
import JahresberichtUebersicht from "./JahresberichtUebersicht";
import JahresberichtMesswerteUebersicht from "./JahresberichtMesswerteUebersicht";

function JahresberichtView(props) {
    const tabBerichte = "Jahresberichte";
    const tabMesswerte = "Messwerte";
    const [anlageId] = useState();
    const readonly = !anlageId ? false : props.modus === "l";
    const {
        values,
    } = useForm({readonly});
    const [selectedTab, setSelectedTab] = useState(tabBerichte);

    const buildTabs = () => {
        const options = [tabBerichte];
        options.push(tabMesswerte);
        return options;
    };

    const backgroundColor = values && values.history ? {background: "#FFFFFF", filter: "sepia()"} : {};
    return (
        <EABetriebsakteMainContainer style={backgroundColor}>
            <EATabs
                value={selectedTab}
                onChange={(newSelectedTab) => setSelectedTab(newSelectedTab)}
                options={buildTabs()}
            />
            <EABetriebsakteDatenContainer>
                {selectedTab === tabBerichte && (
                    <JahresberichtUebersicht betriebId={props.betriebsId}></JahresberichtUebersicht>
                )}
                {selectedTab === tabMesswerte && (
                    <JahresberichtMesswerteUebersicht betriebId={props.betriebsId}></JahresberichtMesswerteUebersicht>
                )}
            </EABetriebsakteDatenContainer>
        </EABetriebsakteMainContainer>
    );
}

export default JahresberichtView;
